import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from 'src/environments/environment';
import { TenantRole } from '../models/dto/tenantRoles';

@Injectable({
  providedIn: 'root'
})
export class TenantRoleService {
  baseUrl = environment.apiUrl;
  constructor(private http: HttpClient) { }

  getTenantRolesByTenant(tenantId: string): Observable<TenantRole> {
    return this.http.get<TenantRole>(this.baseUrl + 'TenantRoles/ByTenant/' + tenantId);
  }

  updateTenantRoles(tenantRoles: TenantRole) {
    return this.http.post(this.baseUrl + 'TenantRoles', tenantRoles);
  }

}
